__turbopack_context__.v({
  "status-bar": "ObjectCard-module-scss-module__LLLOUq__status-bar",
  "title": "ObjectCard-module-scss-module__LLLOUq__title",
});
